import request from "@utils/request";

// 防抖
export const DebounceBy = (fn, t) => {
    let delay = t || 500
    let timer
    return function () {
        let args = arguments;
        if (timer) {
            clearTimeout(timer)
        }
        let callNow = !timer
        timer = setTimeout(() => {
            timer = null
        }, delay)
        if (callNow) fn.apply(this, args)
    }
}

/**
 * 获取汇率
 * @returns {*}
 */
export function getExchangeRate(data) {
    return request.get("/exchange_rate?type=" + data.type);
}

/**
 * trx提现申请
 * @param data
 * @returns {*}
 */
export function addWithdraw(data) {
    return request.get("/trx_withdraw", data);
}

/**
 * 获取hash教程
 * @returns {*}
 */
export function getHashTeach() {
    return request.get("/hash_teach");
}

/**
 * 获取兑换列表
 * @returns {*}
 */
export function getTRXList() {
    return request.get("/get_trx_list");
}